//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            appCode: '1001',
            showDiv: false,
            showView: 1, //展示注册模块或身份证模块
            openId: '', //用户openid
            mobile: '', //用户输入的电话号码
            code: '', //短信验证码
            IDcard: '', //身份证号
            name: '', //姓名
            reNum: 60, //重新获取的时间
            sit: '', //倒计时
            appCode: '1001', 
            isCanGain: true,
            shortLinkCode:this.tool.getUrlParam().slc || "", //短链订单唯一标识
            certIdLast:this.tool.getUrlParam().cardId || "",
            source:this.$route.query.source || "",
            backUrl:this.tool.getUrlParam().backUrl || ""
        };
    },

    created() {
        //sessionStorage.setItem("openId","oWUYuwC1nxLLywrM9tACYpLVIAJg"); //测试使用
        sessionStorage.removeItem('contract'); //清除上次支付合同
        sessionStorage.setItem("appCode","1001"); //系统码
        
        //console.log(this.shortLinkCode+"短链码")
        //console.log(this.shortLinkCode+"短链码")

        if(this.shortLinkCode){//从短链入口进入的
            location.replace(`/#/bargainShort?slc=${this.shortLinkCode}`);

            /*
            this.showDiv = true;
            this.showView = 3;
            sessionStorage.setItem("shortLinkCode",this.shortLinkCode);
            */
           return ;

        }  else {
            this.openId = this.tool.getUrlParam().openId || this.tool.getUrlParam().open_id || sessionStorage.getItem('openId') || '';
            sessionStorage.setItem('openId', this.openId);
            var wechatSource = this.tool.getUrlParam().wechatSource || sessionStorage.getItem('wechatSource');
            if (wechatSource) {
                sessionStorage.setItem('wechatSource', wechatSource);
            } else {
                this.toast('微信来源参数为空，请联系管理员配置',"warn","80%");
                return ;
            }
            //this.getToken();
            this.getInfo();
        }
    },

    methods: {
        //获取token
        /*
        getToken() {
            let self = this;
            self.tool.httpGet('/ncp/api/get_token',res => {
                if (res.data.access_token) {
                    localStorage.setItem('token', res.data.access_token);
                    if (self.openId) {
                        self.checkUser();
                    } else {
                        self.getInfo();
                    }
                } else {
                    self.toast(res.message);
                }
            },

            err => {
                console.log(err);
            })
        },
        */

        getInfo() {
            this.tool.getPlatInfo().then(res => {
                console.log("res======")
                console.log(res)
                console.log("res++++++++++")
                
                let opId = sessionStorage.getItem("openId")

                if (res) {
                    this.openId = res+"";
                    if(this.openId){
                        this.checkUser();
                    }
                } else if (opId) {
                    this.checkUser();
                } else {
                    this.toast('请在微信APP打开此链接');
                }
            });
        },

        /*** 进入页面查询用户是否已经注册 */
        checkUser() {
            let wechatSource = sessionStorage.getItem('wechatSource');
            let openId = sessionStorage.getItem("openId")
            console.log("===>>>>>>>>>>>>>>>>>"+openId)

            this.tool.httpGet(`/ncp/api/weixin/pub_no/user/get_user?wxAppCode=${wechatSource}&openId=${openId}&appCode=${this.appCode}`,res => {
                
                if (res.data == null) {  //没数据,未注册
                    this.showDiv = true;
                    this.showView = 1;
                    return;
                }
                else if (res.data.mobile) {//已注册手机号
                    this.showDiv = true;
                    this.showView = 1;
                    sessionStorage.setItem('mobile', res.data.mobile);

                    //location.replace(`/#/bargain`);
                    
                    // 处理客服进来
                    let custService = this.tool.getUrlParam().custService;
                    if (custService && custService == '1') {
                        let visitorExtraInfo = {
                            phone : res.data.mobile,
                            sourceCode : sessionStorage.getItem('wechatSource'),
                            source :  res.data.extendInfo
                        }
                        //let url = "https://webchat1-bj.tinetcloud.com/chat.html?accessId=7350c29b-6343-432b-83d8-7e8dc6e7ef04&language=zh_CN&visitorExtraInfo=";
                        let url = "https://webchat-bj.clink.cn/chat.html?accessId=7e3de4fc-b134-4d88-8ad6-b0a52f6a9c2c&language=zh_CN&visitorExtraInfo=";
                        location = url + encodeURI(JSON.stringify(visitorExtraInfo))
                    } else {
                        this.$router.push({ name: 'bargain' });
                    }
                } /*else if (res.data.mobile && !res.data.certNo) {
                    //已注册了手机号,还没注册身份证
                    sessionStorage.setItem('mobile', res.data.mobile);
                    this.showDiv = true;
                    this.showView = 2;
                } else if (res.data.certNo) {
                    //已完成注册
                    if(this.source && this.source == "service"){//客服页面标识，获取客服地址
                        location.replace(encodeURI(res.hook));
                    }
                    else{
                        sessionStorage.setItem('mobile', res.data.mobile);
                        sessionStorage.setItem('Icard', res.data.certNo);
                        sessionStorage.setItem('userId', res.data.id);
                        this.$router.push({ name: 'bargain' });
                    }
                }*/
            },

            err => {
                this.showDiv = true;
                this.showView = 1;
            });
        },

        //获取客服地址
        getServiceUrl() {
            /*
            let self = this;
            self.tool.httpPost(`/ncp/getCustmerServiceH5?wechatNo=${this.openId}`,res => {
                if (res.status == 0) {
                    location.replace(encodeURI(res.data));
                }else {
                    self.toast(res.message);
                }
            },
            err => {
                console.log(err);
            })
            */
        },

        /*** 获取短信验证码*/
        gainCode() {
            if (!this.tool.checkPhone(this.mobile)) {
                this.toast('手机号码不正确');
                return;
            }
            let body = {mobile: this.mobile,xk:"f6c1dbc8248a11eea9ec00163e0289a0",xp:"b42ff5bd248a11eea9ec00163e0289a0"}
            this.tool.httpPost(`/ncp/api/weixin/pub_no/user/get_sms_code`,body, res => {
                console.log(res)
                this.reTime();
            },
            err => {
              
                this.toast(err.message);
            });
        },

        /*** 倒计时*/
        reTime() {
            if (this.sit) return;
            this.isCanGain = false;
            this.reNum = 60;
            this.code = '';
            this.sit = setInterval(() => {
                this.reNum -= 1;
                if (this.reNum <= 0) {
                    this.isCanGain = true;
                    clearInterval(this.sit);
                    this.sit = '';
                }
            }, 1000);
        },

        /*** 下一步*/
        registPhone() {
            if (!this.tool.checkPhone(this.mobile)) return this.toast('手机号码不正确');
            if (!this.code) return this.toast('请输入短信验证码');
           
            let tags = this.tool.getUrlParam().wechatSource || sessionStorage.getItem('wechatSource');//用户标签,用于区分来自己哪个公众号
            let d = {
                openId: sessionStorage.getItem("openId"),
                mobile: this.mobile,
                smsCode: this.code,
                tags : tags ,
                appCode: this.appCode
                //tab: this.tool.versions.weixin ? 0 : this.tool.versions.alipay ? 1 : '',
                //wechatSource: sessionStorage.getItem('wechatSource') || ''
            };

            this.tool.httpPost('/ncp/api/weixin/pub_no/user/regist_mobile',d,res => {
                sessionStorage.setItem('mobile', this.mobile);
                this.$router.push({ name: 'bargain' });
                /*
                this.showView = 2; //展示身份证注册模块
                if (!res.isSuccess) {
                    this.toast(res.message);
                }
                */
            },

            err => {
                //console.log(err)
                this.toast(err.message);
            });
        },

        //短链登录验证
        /*
        login(){
            if (!this.certIdLast) return this.toast('请输入身份证后六位');
            let postDate = {
                certNoLast: this.certIdLast,
                shortLinkCode: this.tokenId
            };
            this.tool.httpPost('/ncp/api/weixin/pub_no/user/valid_short_link',postDate,res => {
                //支付状态:0=待支付 10=支付中 20=支付成功 30=支付失败
                if(res.data.payStatus == "0" || res.data.payStatus == "30"){//待支付，支付失败
                    sessionStorage.setItem("bargainInfo",JSON.stringify(res.data));
                    this.$router.push({
                      name: 'bargainShort',
                      query:{
                        tokenId:this.tokenId
                      }
                    });
                }else{
                    this.$router.push({
                      name: 'payResult',
                      params:{
                          payNum : res.data.orderNo
                       }
                    });
                }
            },

            err => {
                this.toast(err.message);
            });
        },
        */
       
        /*** 确定*/
        registIDcard() {
            /*
            //if (!this.tool.checkICard(this.IDcard)) return this.toast('身份认证不正确');
            if (!this.name) return this.toast('请输入姓名');
            let d = {
                openId: this.openId,
                certNo: this.IDcard,
                realName: this.name
            };

            this.tool.httpPost('/ncp/api/weixin/pub_no/user/bind_certno',d,res => {
                sessionStorage.setItem('Icard', this.IDcard);
                sessionStorage.setItem('userId', res.data.id);
                this.toast(res.message, 'success');
                if(this.source && this.source == "service"){//客服页面标识，获取客服地址
                    this.getServiceUrl();
                }else{
                    this.$router.push({ name: 'bargain' });
                }
            },

            err => {
                this.toast(err.message);
            });
            */
        }
    }
  };



// WEBPACK FOOTER //
// ./src/page/login/index.vue